export default __webpack_public_path__ + "../staticImages/mvv_icon.png";